import { colourString } from '@keplerco/core';
import React, { PropsWithChildren } from 'react';
import SkillLevelHelp from '../general/skill-level-help/skill-level-help';

export function EntitiesCardWidget({ title, description, children, showSkillLevelHelp }: PropsWithChildren<{ title: string; description?: string; showSkillLevelHelp?: boolean }>): JSX.Element {
  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3>{title}</h3>
        {showSkillLevelHelp && (
          <div style={{ marginLeft: 'auto' }}>
            <SkillLevelHelp />
          </div>
        )}
      </div>
      {!!description && <p style={{ color: colourString('text_1') }}>{description}</p>}
      <div style={{ marginTop: !!children ? 4 : 0 }}>{children}</div>
    </div>
  );
}
